import axios from '@/libs/api.request'
import { genURLParams } from '@/libs/urlparamhelper'

export const queryLoginWx = (params, urlParams) => {
  return axios.request({
    url: '/third/eyun/queryloginwx' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getLoginWechatAccount = (params, urlParams) => {
  return axios.request({
    url: '/third/eyun/getloginwechataccount' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getAllWechatAccount = (params, urlParams) => {
  return axios.request({
    url: '/third/eyun/getallwechataccount' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getWechatLoginQRCode = (params, urlParams) => {
  return axios.request({
    url: '/third/eyun/getwechatloginqrcode/' + params.eyunWechatAccountId + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const confirmLogin = (params, urlParams) => {
  return axios.request({
    url: '/third/eyun/confirmlogin' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const getFriendList = (params, urlParams) => {
  return axios.request({
    url: '/third/eyun/getfriendlist/' + params.eyunWechatAccountId + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const modifyFriendInfo = (params, urlParams) => {
  return axios.request({
    url: '/third/eyun/modifyfriendinfo' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const sendText = (params, urlParams) => {
  return axios.request({
    url: '/third/eyun/sendtext' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}
